import React, { Component } from 'react';
import './TripPanelFilter.css';
import { inject, observer } from 'mobx-react';

import isEqual from 'lodash/isEqual';
import moment from 'moment';

import AirButton from '../../../../../../common/components/AirButton';
import { DownloadIcon, DayIcon, NightIcon } from '../../../../../../common/icons';

import AirDatePicker from '../../../../../../common/components/AirDatePicker';

@inject('translationsStore', 'commonStore')
@observer
export default class TripPanelFilter extends Component {
  constructor(props) {
    super(props);

    this.state = {
      startDate: this.props.startDate,
      endDate: this.props.endDate
    };
  }

  componentDidUpdate = (prevProps, prevState) => {
    const { startDate, endDate } = prevState;
    if (this.props.startDate && !isEqual(this.props.startDate, startDate)) {
      this.setState({ startDate: this.props.startDate });
    }

    if (this.props.endDate && !isEqual(this.props.endDate, endDate)) {
      this.setState({ endDate: this.props.endDate });
    }
  };

  onChangeStartDate = startDate => {
    this.props.onChange(startDate, this.state.endDate);
    if (moment(startDate).isBefore(moment(this.state.endDate))) {
      return false;
    } else {
      this.props.onChange(startDate, this.state.endDate);
    }
  };

  onChangeEndDate = endDate => {
    if (moment(endDate).isBefore(moment(this.state.startDate))) {
      return false;
    } else {
      this.props.onChange(this.state.startDate, endDate);
    }
  };

  render() {
    const { commonStore, translationsStore, summary } = this.props;
    const { totalDayDrivePercentage, totalDistance, totalDurationInSecond, totalJourney, totalRating } = this.props.summary;
    const { startDate, endDate } = this.state;
    return (
      <React.Fragment>
        {summary && (
          <div className="TripPanelFilter">
            <div className="header">
              <div className="daterange">
                <AirDatePicker
                  onChange={this.onChangeStartDate}
                  selectsStart
                  startDate={startDate}
                  endDate={endDate}
                  duration
                  prefix={translationsStore.translate('tripsPanel.filter.date.from')}
                  selected={startDate}
                />
                <AirDatePicker
                  onChange={this.onChangeEndDate}
                  selectsEnd
                  startDate={startDate}
                  endDate={endDate}
                  prefix={translationsStore.translate('tripsPanel.filter.date.to')}
                  selected={endDate}
                />
              </div>
              <AirButton
                bgcolor="transparent"
                color="var(--selected-color)"
                size="large"
                icon={<DownloadIcon style={{ width: '13px', height: '16px', color: 'var(--selected-color)', marginRight: '11px' }} />}
                label={translationsStore.translate('tripsPanel.filter.download')}
                onClick={this.props.onDownloadTrips}
              />
            </div>
            <div className="summary">
              <div className="headers">
                <div className="header">{translationsStore.translate('tripsPanel.filter.summary.distance')}</div>
                <div className="header">{translationsStore.translate('tripsPanel.filter.summary.time')}</div>
                <div className="header">
                  {translationsStore.translate('tripsPanel.filter.summary.day')}/{translationsStore.translate('tripsPanel.filter.summary.night')}
                </div>
                <div>{translationsStore.translate('tripsPanel.filter.summary.rating')}</div>
              </div>
              <div className="values">
                <div>{(totalDistance || 0).toLocaleString(commonStore.momentLocale)} Km</div>
                <div>{moment.duration(totalDurationInSecond || 0, 'seconds').format('h:mm:ss [h]', { trim: false })}</div>
                <div className="dayNight">
                  <span className="day">
                    <DayIcon style={{ width: '16px', height: '16px' }} />
                    {Math.round((totalDayDrivePercentage || 0) / (totalJourney || 1))}%
                  </span>
                  <span className="night">
                    <NightIcon style={{ width: '14px', height: '14px' }} />
                    {100 - Math.round((totalDayDrivePercentage || 0) / (totalJourney || 1))}%
                  </span>
                </div>

                <div>{Math.round((totalRating || 0) / (totalJourney || 1))}</div>
              </div>
            </div>
          </div>
        )}
      </React.Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/App/ClientListWithMap/ClientDetail/TripPanel/TripPanelFilter/TripPanelFilter.js